// =================================================================================================
// Site JS
// =================================================================================================
'use strict';

jQuery(document).ready(function($) {

  var device = getDevice();

  // ===============================================================================================
  // Sticky only the menu
  // ===============================================================================================
  var stickyElement = $('#cssmenu');
  // excuse my magic numbers
  var SCROLL_DOWN_TARGET = 32;
  var SCROLL_UP_TARGET = 105;
  var bannerOffset = 0;
  var adminShowing = false;
  if($('#wpadminbar').length > 0){
    adminShowing = true;
  }
  //console.log(device);
  window.onscroll = function() {
    // bannerOffset is set in banner visiblility block
    // console.log(bannerOffset);

    if (window.scrollY - document.getElementById("cssmenu").offsetTop > (SCROLL_DOWN_TARGET + bannerOffset)) {
      if (!stickyElement.hasClass('super-sticky')) {
        stickyElement.addClass('super-sticky');
      }
      if(adminShowing){
        stickyElement.addClass('admin-offset');
      }

    }
    if (window.scrollY - document.getElementById("cssmenu").offsetTop < (SCROLL_UP_TARGET + bannerOffset)) {
      if (stickyElement.hasClass('super-sticky')) {
        stickyElement.removeClass('super-sticky');
        stickyElement.removeClass('admin-offset');
      }
    }

  }

  // ===============================================================================================
  // Change font of expanded reponsive menu item
  // ===============================================================================================
  $('.responsive-menu-subarrow').click(function() {
    if($(this).parent().hasClass('active-parent')) {
      $(this).parent().removeClass('active-parent');
    } else {
      $(this).parent().addClass('active-parent');
    }
  });

  // ===============================================================================================
  // Search bar on mobile
  // ===============================================================================================
  $('.search-toggle-button').click(function() {
    if ($('.search-pop-down').is(':visible')) {
      $('.search-toggle-button').css('color','#b35639');
      $('.search-pop-down').hide();
    } else {
      $('.search-pop-down').show();
      $('.search-toggle-button').css('color','#731605');
    }
  });

  // ===============================================================================================
  // Mobile check function
  // ===============================================================================================
  function getDevice() {
    var ieVersion = getIeVersion();

    // -------------------------------------------------------------------------------------------
    // Returns the version of IE (0 if not IE)
    // -------------------------------------------------------------------------------------------
    function getIeVersion() {
      var isTrident;
      var userAgentStr = window.navigator.userAgent;
      var msieIndex = userAgentStr.indexOf('MSIE');
      var result;
    
      if (msieIndex > 0) {
        // IE < 11
        result = parseInt(
          userAgentStr.substring(
            msieIndex + 5,
            userAgentStr.indexOf('.', msieIndex)
          )
        );
      } else {
        isTrident = !navigator.userAgent.match(/Trident\/7\./);

        if (!isTrident) {
          // IE 11
          result = 11;
        } else {
          // Not IE
          result = 0;
        }
      }

      return result;
    }

    return {
      isIe      : (ieVersion !== 0),
      ieVersion : ieVersion,
      isMobile  : (typeof window.orientation !== 'undefined') ||
                    (navigator.userAgent.indexOf('IEMobile') !== -1),
      width     : screen.width
    }
  }

  // ===============================================================================================
  // Home page partner carousel
  // ===============================================================================================
  $('body.home #partner-carousel').on('slide.bs.carousel', function(e) {
    var $elem = $(e.relatedTarget);
    var elemIndex = $elem.index();
    var i;
    var item;
    var itemsVisible = 3;
    var totalItems = $('.carousel-item').length;
    
    if (elemIndex >= totalItems - (itemsVisible - 1)) {
      item = itemsVisible - (totalItems - elemIndex);
  
      for (i = 0; i < item; i++) {
        // Append slide to the right
        $('.carousel-item').eq((e.direction === 'left') ? i : 0).appendTo('.carousel-inner');
      }
    }
  });

  // ===============================================================================================
  // Open all external links in a new tab
  // ===============================================================================================
  $('a').filter('[href^="http"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr('target', '_blank');

  // ===============================================================================================
  // Open all PDFs in a new tab
  // ===============================================================================================
  try {
    $('a[href$=".pdf"]:not([target]').attr('target', '_blank');
  } catch(e) {
    // Do nothing
  }

  // ===============================================================================================
  // Returns the season based on the current date
  // ===============================================================================================
  function getSeason() {
    var now = new Date();
    var month = 1 + now.getMonth();
    var result;

    switch(month) {
    case 12:
    case 1:
    case 2:
      result = 'winter';
      break;

    case 3:
    case 4:
    case 5:
      result = 'spring';
      break;

    case 6:
    case 7:
    case 8:
      result = 'summer';
      break;

    case 9:
    case 10: 
    case 11:
      result = 'fall';
      break;

    default:
      result = 'summer';
      break;
    }

    return result;
  }

  // ===============================================================================================
  // Banner ad
  // ===============================================================================================
  var COOKIE_NAME = 'new-proposals';
  var COOKIE_EXPIRATION = 1;
  var COOKIE_VALUE = 'closed-popup';
  var expandedOffset = 0;
  var collapsedOffset = 0;
  bannerOffset = $('#expanded-banner-wrapper:visible').height();
  $('#banner-ad').show();
  if(!isCookieSet()){
    //$('#banner-ad').show();
    $('#expanded-banner-wrapper').show();
    $('#collapsed-banner-wrapper').hide();
    //bannerOffset = $('#banner-ad:visible').height();
    bannerOffset = $('#collapsed-banner-wrapper:visible').height();
  }

  $('.banner-ad-close').click(function() {
    //bannerOffset = 0;
    //$('#banner-ad').toggle();
    $('#expanded-banner-wrapper').toggle();
    $('#collapsed-banner-wrapper').toggle();
    if(!getCookie('COOKIE_NAME')){
      setCookie(COOKIE_NAME,COOKIE_VALUE,COOKIE_EXPIRATION);
    }
    expandedOffset = $('#expanded-banner-wrapper:visible').height();
    collapsedOffset = $('#collapsed-banner-wrapper:visible').height();
    if(expandedOffset > collapsedOffset){
      bannerOffset = expandedOffset;
    } else {
      bannerOffset = collapsedOffset;
    }
    console.log(bannerOffset);
  })
  $('.banner-ad-link').click(function() {
    //bannerOffset = 0;
    //$('#banner-ad').toggle();
    $('#expanded-banner-wrapper').toggle();
    $('#collapsed-banner-wrapper').toggle();
    if(!getCookie('COOKIE_NAME')){
      setCookie(COOKIE_NAME,COOKIE_VALUE,COOKIE_EXPIRATION);
    }
    expandedOffset = $('#expanded-banner-wrapper:visible').height();
    collapsedOffset = $('#collapsed-banner-wrapper:visible').height();
    if(expandedOffset > collapsedOffset){
      bannerOffset = expandedOffset;
    } else {
      bannerOffset = collapsedOffset;
    }
    console.log(bannerOffset);
  })

  // ===============================================================================================
  // Checks if cookie is set
  // ===============================================================================================
  function isCookieSet() {
    var cookieValue = getCookie(COOKIE_NAME);

    if (cookieValue !== null && cookieValue !== '') {
      return true;
    }

    return false;
  }
  
  // ===============================================================================================
  // Returns the value of the [name] cookie
  // ===============================================================================================
  function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + '=';
    var begin = dc.indexOf('; ' + prefix);
    var end = dc.indexOf(';', begin);

    if (begin === -1) {
      begin = dc.indexOf(prefix);

      if (begin !== 0) {
        return null;
      }
    } else {
      begin += 2;

      if (end === -1) {
        end = dc.length;
      }
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  // ===============================================================================================
  // Sets a [name] cookie with [value] expiring in [days]
  // ===============================================================================================
  function setCookie(name, value, days) {
    var date = new Date();
    var expires;

    if (days) {
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }

    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  // ===============================================================================================
  // Shows a warning to those using IE
  // ===============================================================================================
  function checkForIe() {
    var cookieName = 'ieWarningShown';
  
    if (device.isIe && !getCookie(cookieName)) {
      showIeWarning(cookieName, 7);
    }
  }

  // ===============================================================================================
  // Displays the IE warning
  // ===============================================================================================
  function showIeWarning(cookieName, expDays) {
    var text = 'We noticed you are using Microsoft Internet Explorer to view this site. You '  +
      'might experience some display issues while using this browser. If so, we recommend that ' + 
      'you try viewing the site in a different more current browser in order to view the site ' +
      'properly.';

    var message = '<h3>Browser Warning</h3><p>' + text + '</p>';

    try {
      $.fancybox({
        autoSize  : false,
        content   : message,
        height    : 'auto',
        onClosed: function() {
          setCookie(cookieName, 'true', expDays);
        },
        width     : '50%'
      });
    } catch (e) {
      alert(text);
      setCookie(cookieName, 'true', expDays);
    }
  }

  $('body').addClass(getSeason());

  // checkForIe();

  // Search & filter date range empty "to" date fix
  var datePickers = $('.sf-datepicker');
  var tempDate = '';
  var defaultEndDate = '';
  var defaultStartDate = '';
  var toDate = '';

  if (datePickers.length > 1) {
    if (datePickers.last().val() !== '') {
      toDate = datePickers.last();
      tempDate = new Date(toDate.val());
      defaultEndDate = new Date('01/01/2122');

      if (tempDate >= defaultEndDate) {
        toDate.val('');
      }
    }

    if (datePickers.first().val() !== '') {
      toDate = datePickers.first();
      tempDate = new Date(toDate.val());
      defaultStartDate = new Date();

      if (tempDate !== defaultStartDate) {
        toDate.datepicker('setDate', new Date());
        toDate.val('');
      }
    }
  }

  function setToDatePicker() {
    var datePickers = $('.sf-datepicker');

    // Big assumption that the to date will be teh last date...
    // I didn't see any other identifier unique to it
    if (datePickers.length > 1) {
      if (datePickers.first().val() !== '' && datePickers.last().val() === '') {
        datePickers.last().datepicker('setDate', new Date('01/01/2122'));
      } else if (datePickers.last().val() !== '' && datePickers.first().val() === '') {
        datePickers.first().datepicker('setDate', new Date());
      }
    }
  }

  $('.sf-field-submit').click(function(){
    setToDatePicker();
  });
});
